module.exports = __webpack_public_path__ + "static/media/contact-us-mob-icon.61b81d8f.svg";